
import type { ClerkProp, LoadedClerk } from '@clerk/react-router/types';

function getWindowClerk(): LoadedClerk | undefined {
  const clerk = (window as Window & { Clerk?: ClerkProp }).Clerk;

  if (clerk && typeof clerk === 'object') {
    if ('status' in clerk && (clerk.status === 'ready' || clerk.status === 'degraded')) {
      return clerk as LoadedClerk;
    }

    if ('loaded' in clerk && clerk.loaded && !('status' in clerk)) {
      return clerk as LoadedClerk;
    }
  }

  return undefined;
}

export async function getClerkClient(timeoutMs = 5000): Promise<LoadedClerk | undefined> {
  const readyClerk = getWindowClerk();
  if (readyClerk) return readyClerk;

  const startedAt = Date.now();
  while (Date.now() - startedAt < timeoutMs) {
    const clerk = getWindowClerk();
    if (clerk?.loaded) {
      return clerk;
    }

    await new Promise<void>((resolve) => {
      window.setTimeout(resolve, 25);
    });
  }

  return getWindowClerk();
}

export async function getAuthHeader(): Promise<string> {
  const clerk = await getClerkClient();
  const token = await clerk?.session?.getToken({ template: 'studium33-jwt' });
  if (!token) return '';
  return `Bearer ${token}`;
}


export async function signOut(params?: URLSearchParams | string, redirectUrl?: string): Promise<void> {
  await (await getClerkClient())?.signOut();
  localStorage.clear();
  sessionStorage.clear();
  const urlParams = params ? `?${new URLSearchParams(params).toString()}` : '';
  window.location.href = redirectUrl ? `/${redirectUrl + urlParams}` : `/login${urlParams}`;
}
